<div class="switch-event-wrapper">
  <div class="switch-event">

    <!-- Desktop -->

    <div class="ui-current-events">
      <h6><span>Upcoming Events</span></h6>
      <div class="event-item-wrapper"
           (click)="onEventSelect(event)"
           *ngFor="let event of eventService?.events"
           [ngClass]="{'active': event.participantId === eventService?.selectedEvent?.participantId}">
        <div class="event-item cursor-hand {{event?.cssClass}}">
          <div>
            <h3>{{ event?.label }}</h3>
            <div class="event-date">
              {{event?.date | date:'MMMM dd, yyyy'}}
              {{ event?.time }}
              {{event?.timezone}}
              <span class="program">{{event?.programGroupName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="eventService?.pastEvents.length > 0" class="ui-past-events">
      <h6><span>Past Events</span></h6>

      <div class="event-item-wrapper"
           (click)="onEventSelect(event)"
           *ngFor="let event of eventService?.pastEvents"
           [ngClass]="{'active': event.participantId === eventService?.selectedEvent?.participantId}">
        <div class="event-item cursor-hand {{event?.cssClass}}">
          <div>
            <h3>{{ event?.label }}</h3>
            <div class="event-date">
              {{event?.date | date:'MMMM dd, yyyy'}}
              {{ event?.time }}
              {{event?.timezone}}
              <span class="program">{{event?.programGroupName}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>